import React from "react"
import { Container } from "reactstrap"
import ReactPlayer from "react-player"
import ContainerMax from "components/shared/ContainerMax"
import ContentMax from "components/shared/ContentMax"
import BlockTitle from "components/shared/BlockTitle"

const VideoBlock = (props) => {
	const { title, video } = props.block
	if (video !== null) {
		return (
			<ContainerMax className="py-4">
				<ContentMax>
					{title &&
						<BlockTitle $baseheading $uppercase>
							{title}
						</BlockTitle>
					}
					<ReactPlayer
						url={video}
						controls={true}
						className="ratio ratio-16x9"
						width="100%"
						height="auto"
					/>
					{/* {props.data.caption &&
							<figcaption><p dangerouslySetInnerHTML={{ __html: props.data.caption }} /></figcaption>
					} */}
				</ContentMax>
			</ContainerMax>
		)
	}
	return ""
}

export default VideoBlock